import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { ContributoUnificatoEditComponent } from './sezione-economica-contributo-unificato-edit.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-edit-contributo-unificato]',
  templateUrl: 'sezione-economica-mod-edit-contributo-unificato.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ModContributoUnificatoEditComponent {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  isFs: boolean = PropertiesSettings.ID_TENANTS_FS();
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formContributoUnificatoEdit') formContributoUnificatoEdit: ContributoUnificatoEditComponent;

  inizializza(sezione: SezioneEconomica, fascicolo: FascicoloFull, urlInsert: string, recuperoCrediti: boolean = false) {
    openModal('modaleContributoUnificatoEdit');
      this.formContributoUnificatoEdit.inizializza(sezione, fascicolo, urlInsert, recuperoCrediti);
  }

  createForm() {
      this.formContributoUnificatoEdit.createForm();
  }

  manageModal(sezioneEconomica: SezioneEconomica) {
      closeModal('modaleContributoUnificatoEdit');
      this.onReturn.emit(sezioneEconomica);
  }
}
